module.exports = __webpack_public_path__ + "static/media/stedelijk.ab071565.jpg";